import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeStyle, SafeUrl } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) {}
    public transform(value: any, type: string): SafeHtml | SafeStyle | SafeUrl | SafeResourceUrl | string | null {
        switch (type) {
            case 'html':
                // Sanitize rather than bypass: remarks/comments are user-authored and must not run scripts.
                // DOMPurify (unlike Angular's sanitizer) keeps inline styles such as text color.
                return this.sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(value ?? ''));
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
